// extracted by mini-css-extract-plugin
module.exports = {"bandera":"Bandera_bandera__1NUiB"};